import React, { ElementType } from "react";

import { Link, SvgIcon } from "../../components";
import { ShoppingBagIcon, MainLogo, HeartIconEmpty } from "../../icons";

const defaultIcons = [HeartIconEmpty, ShoppingBagIcon];

interface IMobileMenuHeaderHome {
  onLogoClick?: () => void;
  logoHref?: string;
  menuItems?: {
    onClick?: () => void;
    href: string;
    icon: ElementType | string;
    id: string;
  }[];
}

const MobileMenuHeaderHome = ({
  onLogoClick = () => {},
  logoHref = "/",
  menuItems = defaultIcons.map((icon, index) => ({
    icon,
    href: "/",
    id: String(index),
  })),
}: IMobileMenuHeaderHome) => {
  return (
    <>
      <div className="flex-grow-1">
        <Link
          classes={{ root: "text-color-blue" }}
          href={logoHref}
          onClick={onLogoClick}
        >
          <>
            <SvgIcon
              icon={MainLogo}
              isIcon={false}
              width={155}
              height={16}
              classes={{ root: "header-brand__desktop" }}
            />
            <SvgIcon
              icon={MainLogo}
              isIcon={false}
              width={116}
              height={13}
              classes={{ root: "header-brand__mobile" }}
            />
          </>
        </Link>
      </div>
      {menuItems.map(({ href, onClick, icon, id }) => (
        <Link
          key={id}
          classes={{ root: "ms-6 text-color-blue" }}
          href={href}
          onClick={onClick}
        >
          <SvgIcon icon={icon} />
        </Link>
      ))}
    </>
  );
};

export default MobileMenuHeaderHome;
